import React, { useState } from "react";
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import { CircularProgress } from "@mui/material";
import axios from "axios";
import settings from "../../config/settings";
import { useHistory } from "react-router";
import { handleApiError } from "../../session/session-expire";

const ChatDeleteConfirmation = ({
  isDeleteConfirmationOpen,
  setIsDeleteConfirmationOpen,
  selectedChatConvId,
  handleSaveHistory,
  conversationId,
  handleClearConversion
}) => {
  const history = useHistory();
  const [isDeleteChatLoading, setIsDeleteChatLoading] = useState(false);
  const [TOKEN] = useState(localStorage.getItem("access_token"));
  const [user_id] = useState(localStorage.getItem("userId"));


  const handleDelete = async () => {
    try {
      setIsDeleteChatLoading(true);
      const response = await axios.delete(
        `${settings.serverUrl}/history/delete`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${TOKEN}`,
          },
          data: {
            conversation_id: selectedChatConvId,
            user_id: user_id
          },
        }
      );
      console.log("Delete response:", response);
      if(response?.status){
        setIsDeleteConfirmationOpen(false);
        handleSaveHistory(null, true);
        if(conversationId === selectedChatConvId){
            handleClearConversion();
        }
      }
    } catch (error) {
      if (error.response) {
        handleApiError(error, history);
        console.error("API Error:", error.response.data);
      } else if (error.request) {
        console.error("No Response:", error.request);
      } else {
        console.error("Error:", error.message);
      }
    } finally {
      setIsDeleteChatLoading(false);
    }
  };

  return (
    <CModal
      alignment="center"
      scrollable
      show={isDeleteConfirmationOpen}
      onClose={() => setIsDeleteConfirmationOpen(!isDeleteConfirmationOpen)}
      size="md"
    >
      <CModalHeader closeButton>
        <CModalTitle>Are you sure you want to delete this item?</CModalTitle>
      </CModalHeader>
      <CModalBody>
        The history of this chat session will permanently removed.
      </CModalBody>
      <CModalFooter>
        <CButton color="primary" onClick={handleDelete}>
          {isDeleteChatLoading ? <CircularProgress size={20} /> : "Delete"}
        </CButton>{" "}
        <CButton
          color="secondary"
          onClick={() => setIsDeleteConfirmationOpen(!isDeleteConfirmationOpen)}
        >
          Cancel
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default ChatDeleteConfirmation;
